import React from 'react'
import { connect } from 'react-redux'
import {
  imageryAndTopographyGoogle as topoGoogle,
  imageryAndTopographyOthers as topoOthers,
  multiTile,
  multiTileLayersXYZ,
  normalizeCloudfrontUrl,
  overlayMaxZoom
} from './map-types'
import { timeLayerOverlay } from './map-types/timeLayer'
import { isTimeLayer } from '../../../lib/timeLayers/timeline'
import isNil from 'lodash/isNil'
import { setDownloaderOptions } from './downloader'
import { fetchVendorObjects } from '../../../action/vendor-actions'
import { activeVendorsAdd } from '../../../action/active-vendors'
import { removeZoomListener } from './map-types'
import { activeLayerIds, visibleLayerIds } from '../../../lib/layerVisibility'

class RenderLayers extends React.Component {
  constructor(props) {
    super(props)
    this.dlConfig = false
  }


  drawOverlays() {
    const { activeLayers, activeVendors, activeVendorsAdd, fetchVendorObjects, layersDictionary, mapReference, vendors, auth } = this.props,
      layerData = activeLayers.map(id => layersDictionary[id]).filter(layer => !isNil(layer)),
      toRemove = [],
      overlays = layerData.sort((a, b) => a.drawOrder - b.drawOrder).map(layer => {
        //upscaleZoomLevel, maxZoomLevel
        if (layer.id == 81) {
          if (mapReference.mapTypeId !== 'hybrid') {
            topoGoogle(layer, mapReference)
          }
          return null
        } else if (layer.id == 891) {
          if (mapReference.mapTypeId !== 'satellite') {
            topoGoogle(layer, mapReference)
          }
          return null
        }
        else if (layer.id == 82) {
          if (mapReference.mapTypeId !== 'terrain') {
            topoGoogle(layer, mapReference)
          }
          return null
        } else if (layer.layerNodeId === 5) {
          const baseMap = mapReference.mapTypes[mapReference.mapTypeId]
          if (isNil(baseMap) || isNil(baseMap.alt) || baseMap.alt.id !== layer.id) {
            topoOthers(layer, { mapInstance: mapReference })
          }
          return null
        } else {
          if (layer.vendorId) {
            if (!vendors[layer.vendorId]) {
              fetchVendorObjects(layer)
                .then(() => {
                  activeVendorsAdd(layer.vendorId)
                })
            } else if (activeVendors.indexOf(layer.vendorId) === -1) {
              activeVendorsAdd(layer.vendorId)
            }
          }
          if (isTimeLayer(layer)) {
            // Weather layers with a time bar: frames swap inside the overlay's tiles.
            return timeLayerOverlay(layer, {
              liveTemplate: normalizeCloudfrontUrl(layer.cloudfrontUrl),
              maxZoom: overlayMaxZoom(layer)
            })
          } else if (layer.cloudfrontUrl) {
            return multiTileLayersXYZ({ mapInstance: mapReference, filters: () => { return this.props.filters }, layersDictionary }, layer)
          } else {
            return multiTile(layer, { mapInstance: mapReference, filters: () => { return this.props.filters } }, true)
          }
          // return overlayImage(layer, { mapInstance: mapReference, filters: () => { return this.props.filters } }, auth.token)
        }
      })

    // WEB-7072: the zoom ceiling is applied PER OVERLAY (see overlayMaxZoom in
    // map-types) rather than by clamping the whole map here. Clamping the map made
    // the shallowest active overlay cap the satellite basemap too.

    // Build toRemove
    mapReference.overlayMapTypes.forEach((overlay, idx) => {
      if (activeLayers.indexOf(overlay?.alt?.id) === -1) {
        toRemove.push({ idx: idx, overlay: overlay })
      }
    })

    // toRemove.forEach((item, idx) => {
    //   removeZoomListener(item.overlay?.alt?.id)
    //   mapReference.overlayMapTypes.removeAt(item.idx)
    // })

    // ✅ Remove in reverse order
    toRemove
      .sort((a, b) => b.idx - a.idx) // sort descending by index
      .forEach(item => {
        removeZoomListener(item.overlay?.alt?.id);
        mapReference.overlayMapTypes.removeAt(item.idx);
      });

    overlays.filter(layer => layer !== null).forEach((overlay, idx) => {
      const renderedOverlay = mapReference.overlayMapTypes.getAt(idx)
      if (!renderedOverlay) {
        mapReference.overlayMapTypes.setAt(idx, overlay)
      } else if (renderedOverlay.alt.id !== overlay.alt.id) {
        mapReference.overlayMapTypes.insertAt(idx, overlay)
      }
    })
  }


  render() {
    if (this.props.mapReference !== null) {
      if (!this.dlConfig) {
        this.dlConfig = true
        setDownloaderOptions(this.props.mapReference)
      }
      if (this.props.selectedTab == "map") {
        this.drawOverlays()
      }
    }
    return null
  }
}

const mapStateToProps = state => ({
  // The eye toggle (WEB-7048) strips the user's data layers out of this list while it is
  // off, leaving only the basemap. drawOverlays() diffs whatever it gets here against the
  // overlays already on the map, so hiding and re-showing needs nothing else: the diff
  // removes them on the way out and puts them back on the way in.
  activeLayers: visibleLayerIds({
    activeIds: activeLayerIds(state.userSettings),
    layersDictionary: state.layersDictionary,
    layersVisible: state.layersVisible
  }),
  layersDictionary: state.layersDictionary,
  filters: state.filters,
  mapReference: typeof state.mapReference === 'function' ? state.mapReference() : null,
  activeVendors: state.activeVendors,
  vendors: state.vendors,
  auth: state.auth,
  selectedTab: state.selectedTab
})

const mapDispatchToProps = dispatch => ({
  fetchVendorObjects: id => dispatch(fetchVendorObjects(id)),
  activeVendorsAdd: id => dispatch(activeVendorsAdd(id))
})

export default connect(mapStateToProps, mapDispatchToProps)(RenderLayers)
